export function getFormatter() {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0
    });
    return function (value) {
        if (!value) {
            value = 0;
        }
        return formatter.format(value);
    };
}
export function removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
}
export function maxLenghtInput(event, maxLength) {
    const input = event.target;
    if (input.value.length > maxLength) {
        input.value = input.value.slice(0, maxLength);
    }
    return input.value;
}
export function allowPositiveValues(event) {
    const value = parseInt(event.target.value);
    if (value <= 0 || isNaN(value)) {
        event.target.value = "";
    }
}
const colors = [
    "#75F2A0",
    "#F9EBEA",
    "#EBDEF0",
    "#D4E6F1",
    "#D1F2EB",
    "#F1948A",
    "#F9E79F",
    "#C39BD3",
    "#A3E4D7",
    "#F5BA86",
    "#75F2E9",
    "#F5A3D7",
    "#75AEF2",
    "#F275E1",
    "#F2758A",
    "#F2AC75",
    "#CAF275",
    "#90F275",
    "#BD75F2",
    "#F5F086",
    "#E575F2",
    "#F5A3C0",
    "#F2D075",
    "#CABC99",
    "#F58686",
    "#86F5CB",
    "#86E4F5",
    "#AD86F5",
    "#E0A3F5",
    "#86A8F5",
];
export function getColor(box) {
    return colors[box % 30];
}
